import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorBonusDerivatives = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.26 2.77 2.77 0 0 0-2.19 2.262L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.05.378.361.668.742.69l-.028.005a.895.895 0 0 0-.722.745.834.834 0 0 0-.681-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
    <path fill="#F7A600" d="M10.5 14h3v7h-3v-7Z" />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M7.583 5.6a.738.738 0 0 1 1.052.007l1.593 1.643H8.19l-.606-.606a.738.738 0 0 1 0-1.045ZM6.17 7.25a2.24 2.24 0 0 1 3.54-2.687l2.32 2.39 2.318-2.39a2.239 2.239 0 0 1 3.54 2.687H20c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 20 12.75h-1.268c.012.082.018.165.018.25v7A1.75 1.75 0 0 1 17 21.75H7A1.75 1.75 0 0 1 5.25 20v-7c0-.085.006-.168.018-.25H4A1.75 1.75 0 0 1 2.25 11V9c0-.966.784-1.75 1.75-1.75h2.171Zm.829 4h13a.25.25 0 0 0 .25-.25V9a.25.25 0 0 0-.25-.25H4a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h3Zm0 1.5a.25.25 0 0 0-.25.25v7c0 .138.112.25.25.25h10a.25.25 0 0 0 .25-.25v-7a.25.25 0 0 0-.25-.25H7Zm8.426-7.143L13.833 7.25h2.038l.607-.606a.738.738 0 1 0-1.052-1.037Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorBonusDerivatives;
